module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 3